import { useState } from 'react';

const STORAGE_KEY = 'medicine-tracker';

function daysAgo(d: number, h = 0): string {
  return new Date(Date.now() - (d * 24 + h) * 3600_000).toISOString();
}

const FIXTURES: Record<string, Record<string, string[]>> = {
  empty: {},
  'many entries': {
    Ibuprofen: [
      daysAgo(0, 1),
      daysAgo(0, 7),
      daysAgo(1, 2),
      daysAgo(1, 10),
      daysAgo(2, 1),
      daysAgo(2, 8),
      daysAgo(3, 3),
      daysAgo(4, 0),
      daysAgo(5, 6),
    ],
  },
  'many medicines': {
    Ibuprofen:   [daysAgo(0, 2), daysAgo(1, 4)],
    'Vitamin D': [daysAgo(0, 1), daysAgo(2, 0)],
    Melatonin:   [daysAgo(0, 8), daysAgo(1, 8)],
    Paracetamol: [daysAgo(0, 3)],
    Zinc:        [daysAgo(1, 0), daysAgo(3, 2)],
    Magnesium:   [daysAgo(0, 5), daysAgo(2, 5)],
  },
  'many medicines + many entries': {
    Ibuprofen:   [daysAgo(0, 1), daysAgo(0, 7), daysAgo(1, 2), daysAgo(1, 10), daysAgo(2, 1), daysAgo(3, 4), daysAgo(4, 0)],
    'Vitamin D': [daysAgo(0, 2), daysAgo(1, 3), daysAgo(2, 3), daysAgo(3, 3), daysAgo(4, 3)],
    Melatonin:   [daysAgo(0, 8), daysAgo(1, 8), daysAgo(2, 8), daysAgo(3, 8), daysAgo(4, 8)],
    Paracetamol: [daysAgo(0, 3), daysAgo(0, 9), daysAgo(1, 3), daysAgo(1, 9), daysAgo(2, 3)],
    Zinc:        [daysAgo(0, 0), daysAgo(1, 0), daysAgo(2, 0), daysAgo(3, 0)],
    Magnesium:   [daysAgo(0, 5), daysAgo(1, 5), daysAgo(2, 5), daysAgo(3, 5), daysAgo(4, 5)],
  },
};

export default function DevFixtures() {
  const [open, setOpen] = useState(false);

  const load = (key: string) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(FIXTURES[key]));
    window.location.reload();
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end gap-2">
      {open && (
        <div className="flex flex-col gap-1 bg-zinc-900 border border-zinc-700 rounded-lg p-3 text-xs">
          <p className="text-zinc-500 uppercase tracking-widest text-[10px] mb-1">fixtures</p>
          {Object.keys(FIXTURES).map(key => (
            <button
              key={key}
              onClick={() => load(key)}
              className="text-left px-3 py-1.5 rounded-md text-zinc-400 hover:text-white hover:bg-zinc-800 transition-colors duration-150"
            >
              {key}
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen(o => !o)}
        className="w-8 h-8 rounded-full bg-zinc-800 border border-zinc-700 text-zinc-500 hover:text-white hover:border-zinc-500 text-xs font-mono transition-colors duration-150 flex items-center justify-center"
        title="Dev fixtures"
      >
        {open ? '×' : 'fx'}
      </button>
    </div>
  );
}
